import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { URLS } from "../../../helpers/url";
import { useDispatch } from "react-redux";
import { authData } from "../../../helpers/stores/actions/auth";
import { saveToStorage } from "../../../helpers/storage";
import { setApiMessage } from "../../../helpers/notification";
import Page from "../../../component/Page";
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Checkbox,
  Link,
  Button,
} from "@mui/material";
import "../auth.scss";
// import { ReactComponent as AuthLogo } from "../../../assets/images/auth-logo.svg";
import { ReactComponent as AuthLogoLogin } from "../../../assets/images/auth-login.svg";

const ForgotPwdview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [whoIs, setWhoIs] = useState("customer");
  return (
    <Page title="Forgot password">
      <Box className="auth-wrap signin" component={"section"}>
        <Box className="col-wrap">
          <Box className="col-left">
            <Box className="form-wrap primary">
              <h1>Forgot Password</h1>

              <Formik
                initialValues={{
                  email: "",
                  //   password: "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .email("Must be a valid email.")
                    .max(255)
                    .required("This field is required."),
                })}
                onSubmit={(formVal) => {
                  const bodyFormData = new FormData();

                  bodyFormData.append("email", formVal.email);
                  bodyFormData.append("type", whoIs);
                  axios
                    .post(URLS.baseURL + URLS.forgotPassword, bodyFormData)
                    .then((res) => {
                      if (res?.data?.data) {
                        if (res?.data?.success === true) {
                          navigate("/auth/sign-in");
                        }
                      }

                      setApiMessage("success", res?.data?.message);
                    })
                    .catch((err) => {
                      setApiMessage("error", err?.response?.data?.message);
                    });
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  touched,
                  values,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box className="form-inner">
                      <Box className="radio-wrap">
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="customer"
                          name="radio-buttons-group"
                          row
                          disableElevation
                          disableRipple
                          disableFocusRipple
                          disableTouchRipple
                        >
                          <FormControlLabel
                            value="customer"
                            control={
                              <Radio
                                checked={whoIs === "customer"}
                                onClick={() => {
                                  setWhoIs("customer");
                                }}
                              />
                            }
                            label="Customer"
                          />
                          <FormControlLabel
                            value="company"
                            control={
                              <Radio
                                checked={whoIs === "company"}
                                onClick={() => {
                                  setWhoIs("company");
                                }}
                              />
                            }
                            label="Company"
                          />
                        </RadioGroup>
                      </Box>
                      <Box className="input-wrap">
                        <lable>Email address</lable>
                        <TextField
                          error={Boolean(touched.email && errors.email)}
                          helperText={touched.email && errors.email}
                          id="email"
                          placeholder="Your email"
                          variant="outlined"
                          focused
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                      </Box>

                      <Button type="submit" className="submit-btn" fullWidth>
                        Send
                      </Button>
                      <p className="account-text">
                        <b>
                          <NavLink className="createaccount" to="/auth/sign-in">
                            {" "}
                            Sign in
                          </NavLink>
                        </b>
                      </p>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          </Box>
          <Box className="col-right">
            <Box className="content">
              <AuthLogoLogin />
            </Box>
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

export default ForgotPwdview;
